/* KIS 360°-weergave (snippets/kis-product-360.liquid). Geen externe library: frames vooraf laden,
   draaien met slepen, schuifbalk of pijltjestoetsen. Bij openen draait de schoen één keer rond. */
if (!customElements.get('kis-360')) {
  class Kis360 extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      try {
        this.frames = JSON.parse(this.dataset.frames || '[]');
      } catch (e) {
        this.frames = [];
      }
      if (this.frames.length < 2) return;

      this.index = 0;
      this.toggleButton = this.querySelector('[data-kis-360-open]');
      this.stage = this.querySelector('.kis-360__stage');
      this.canvas = this.querySelector('[data-kis-360-canvas]');
      this.img = this.querySelector('[data-kis-360-img]');
      this.loading = this.querySelector('[data-kis-360-loading]');
      this.progress = this.querySelector('[data-kis-360-progress]');
      this.range = this.querySelector('[data-kis-360-range]');

      this.toggleButton.addEventListener('click', () => this.open());
      this.querySelector('[data-kis-360-close]').addEventListener('click', () => this.close());
      this.range.addEventListener('input', () => {
        this.stopIntro();
        this.markTouched();
        this.show(Number(this.range.value));
      });
      this.stage.addEventListener('keydown', (event) => this.onKeydown(event));

      this.canvas.addEventListener('pointerdown', (event) => this.onPointerDown(event));
      this.canvas.addEventListener('pointermove', (event) => this.onPointerMove(event));
      this.canvas.addEventListener('pointerup', (event) => this.onPointerUp(event));
      this.canvas.addEventListener('pointercancel', (event) => this.onPointerUp(event));
    }

    open() {
      this.stage.hidden = false;
      this.classList.add('is-open');
      this.toggleButton.setAttribute('aria-expanded', 'true');
      if (!this.loadStarted) this.load();
      else this.playIntro();
      this.canvas.focus({ preventScroll: true });
    }

    close() {
      this.stopIntro();
      this.stage.hidden = true;
      this.classList.remove('is-open');
      this.toggleButton.setAttribute('aria-expanded', 'false');
      this.toggleButton.focus({ preventScroll: true });
    }

    load() {
      this.loadStarted = true;
      this.img.src = this.frames[0];
      let done = 0;
      const total = this.frames.length;
      this.images = this.frames.map((src) => {
        const image = new Image();
        image.decoding = 'async';
        image.onload = image.onerror = () => {
          done += 1;
          this.progress.textContent = `${Math.round((done / total) * 100)}%`;
          if (done === total) this.onReady();
        };
        image.src = src;
        return image;
      });
    }

    onReady() {
      this.loading.hidden = true;
      this.classList.add('is-ready');
      this.playIntro();
    }

    show(index) {
      const total = this.frames.length;
      this.index = ((index % total) + total) % total;
      this.img.src = this.frames[this.index];
      this.range.value = this.index;
    }

    /* Eén rondje bij openen, zodat duidelijk is dat de schoen draait */
    playIntro() {
      if (!this.classList.contains('is-ready')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stopIntro();
      const total = this.frames.length;
      const start = this.index;
      const duration = 1600;
      const startTime = performance.now();
      const step = (now) => {
        const t = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - t, 3);
        this.show(start + Math.round(eased * total));
        if (t < 1) this.introFrame = requestAnimationFrame(step);
        else this.introFrame = null;
      };
      this.introFrame = requestAnimationFrame(step);
    }

    stopIntro() {
      if (this.introFrame) cancelAnimationFrame(this.introFrame);
      this.introFrame = null;
    }

    markTouched() {
      this.classList.add('is-touched');
    }

    onPointerDown(event) {
      if (event.button !== undefined && event.button !== 0) return;
      this.stopIntro();
      this.dragging = true;
      this.dragStartX = event.clientX;
      this.dragStartIndex = this.index;
      this.canvas.classList.add('is-dragging');
      this.canvas.setPointerCapture?.(event.pointerId);
    }

    onPointerMove(event) {
      if (!this.dragging) return;
      const delta = event.clientX - this.dragStartX;
      if (Math.abs(delta) > 4) this.markTouched();
      /* Eén keer de breedte slepen = één volledige draai */
      const pixelsPerFrame = this.canvas.clientWidth / this.frames.length;
      this.show(this.dragStartIndex - Math.round(delta / pixelsPerFrame));
    }

    onPointerUp(event) {
      if (!this.dragging) return;
      this.dragging = false;
      this.canvas.classList.remove('is-dragging');
      this.canvas.releasePointerCapture?.(event.pointerId);
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.target === this.range) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        this.stopIntro();
        this.markTouched();
        this.show(this.index + (event.key === 'ArrowRight' ? -1 : 1));
      }
    }
  }

  customElements.define('kis-360', Kis360);
}
